export const CategoryApi = Symbol.for('CategoryApi');
